import { render, staticRenderFns } from "./LottieConfig.vue?vue&type=template&id=61215535"
import script from "./LottieConfig.vue?vue&type=script&lang=js"
export * from "./LottieConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports